import {
  UnitOfMeasurement,
  UnitOfMeasurementCode,
} from 'constants/unitOfMeasurement';
import { UnitsOfMeasurementModelType } from 'interfaces/unitOfMeasurement';

export const INDUSTRIAL_MAPPING: UnitsOfMeasurementModelType[] = [
  {
    key: 'hookHeight',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'hookHeight',
        unit: UnitOfMeasurement.feet,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'hookHeightMt',
        unit: UnitOfMeasurement.meter,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'hookHeightMt',
        unit: UnitOfMeasurement.meter,
      },
    },
  },
  {
    key: 'typicalClearHeightMin',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'typicalClearHeightMin',
        unit: UnitOfMeasurement.feet,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'typicalClearHeightMinMt',
        unit: UnitOfMeasurement.meter,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'typicalClearHeightMinMt',
        unit: UnitOfMeasurement.meter,
      },
    },
  },
  {
    key: 'typicalClearHeightMax',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'typicalClearHeightMax',
        unit: UnitOfMeasurement.feet,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'typicalClearHeightMaxMt',
        unit: UnitOfMeasurement.meter,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'typicalClearHeightMaxMt',
        unit: UnitOfMeasurement.meter,
      },
    },
  },
  {
    key: 'outsideStorage',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'outsideStorageAcres',
        unit: UnitOfMeasurement.acres,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'outsideStorageAcres',
        unit: UnitOfMeasurement.acres,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'outsideStorageHectares',
        unit: UnitOfMeasurement.hectares,
      },
    },
  },
];
